import { Bestillingssammendrag } from "codegen";
import styled from "styled-components";

import { Direction, Flex, Justify, Wrap } from "@ntemarked/mittne-components/dist/Flex/Flex";

import { OrderFilterTable } from "pages/Strombestilling/components/OrderFilterTable";
import { PurreFilter } from "pages/Strombestilling/orders/components/Purrefilter";

export default function OrdersFilters({
	data,
	status,
	setStatus,
	source,
	setSource,
	product,
	setProduct,
	pending,
	setPending,
}: Readonly<{
	data: Bestillingssammendrag;
	status: string | null;
	setStatus: (newValue?: string) => void;
	source: string | null;
	setSource: (newValue?: string) => void;
	product: string | null;
	setProduct: (newValue?: string) => void;
	pending: string | null;
	setPending: (newValue?: string) => void;
}>) {
	return (
		<FilterWrapper>
			<Flex direction={Direction.row} gap="2rem" alignItems={Justify.start} wrap={Wrap.wrap}>
				{data?.perStatus && Boolean(Object.entries(data?.perStatus).length) && (
					<OrderFilterTable name="Status" data={data?.perStatus} selected={status} setSelected={setStatus} />
				)}
				{data?.perKanal && Boolean(Object.entries(data.perKanal).length) && (
					<OrderFilterTable name="Kanal" data={data.perKanal} selected={source} setSelected={setSource} />
				)}
				<PurreFilter selected={pending} setSelected={setPending} />
				{data?.perProdukt && Boolean(Object.entries(data.perProdukt).length) && (
					<OrderFilterTable name="Produkt" data={data.perProdukt} selected={product} setSelected={setProduct} />
				)}
				{data?.perSalgskanal && Boolean(Object.entries(data.perSalgskanal).length) && (
					<OrderFilterTable name="Salgskanal" data={data.perSalgskanal} selected={source} setSelected={setSource} />
				)}
			</Flex>
		</FilterWrapper>
	);
}

export const FilterWrapper = styled.div`
	padding: 32px;
	background-color: #f6f6f6;
	border-radius: 16px;
`;
